/* Links card: draws the QR code on desktop and downloads the contact as a vCard. */
(function () {
  const DESKTOP_QUERY = '(min-width: 990px)';
  // iOS asks "Download?" before saving; the blob URL has to outlive that prompt.
  const BLOB_URL_LIFETIME_MS = 60000;

  function escapeVCardValue(value) {
    return String(value)
      .replace(/\\/g, '\\\\')
      .replace(/\r\n|\r|\n/g, '\\n')
      .replace(/,/g, '\\,')
      .replace(/;/g, '\\;');
  }

  function buildVCard(contact) {
    const name = escapeVCardValue(contact.name);
    // N is required by vCard 3.0; X-ABShowAs makes iOS file the card as a company, not a person.
    const lines = ['BEGIN:VCARD', 'VERSION:3.0', 'N:;;;;', `FN:${name}`, `ORG:${name}`, 'X-ABShowAs:COMPANY'];
    if (contact.phone) lines.push(`TEL;TYPE=WORK,VOICE:${contact.phone.replace(/[^\d+]/g, '')}`);
    if (contact.email) lines.push(`EMAIL;TYPE=INTERNET:${escapeVCardValue(contact.email)}`);
    if (contact.address) lines.push(`ADR;TYPE=WORK:;;${escapeVCardValue(contact.address)};;;;`);
    if (contact.url) lines.push(`URL:${contact.url}`);
    lines.push('END:VCARD');
    return lines.join('\r\n') + '\r\n';
  }

  function qrSvg(text, qrcode = window.qrcode) {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
  }

  function contactFrom(root) {
    const data = root.dataset;
    return { name: data.vcardName, phone: data.vcardPhone, email: data.vcardEmail, address: data.vcardAddress, url: data.vcardUrl };
  }

  function downloadVCard(contact) {
    const blob = new Blob([buildVCard(contact)], { type: 'text/vcard;charset=utf-8' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = 'aainterior.vcf';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(href), BLOB_URL_LIFETIME_MS);
  }

  // Instagram and Facebook webviews ignore blob downloads, so the button would do nothing there.
  function isInAppBrowser(userAgent) {
    return /\b(Instagram|FBAN|FBAV|FB_IAB)\b/.test(userAgent || '');
  }

  function showInAppNote(root) {
    root.querySelectorAll('[data-links-card-save-note]').forEach((note) => {
      note.hidden = false;
    });
  }

  function drawQr(qrHost, qrcode) {
    if (!qrHost.childElementCount && typeof qrcode === 'function') {
      qrHost.innerHTML = qrSvg(qrHost.dataset.url, qrcode);
    }
  }

  // The QR is desktop-only, so its library is fetched only once a desktop layout needs it.
  function showQr(root, { qrcode, loadQrLibrary }) {
    const qrHost = root.querySelector('[data-links-card-qr]');
    if (!qrHost || qrHost.childElementCount) return;
    if (typeof qrcode === 'function') {
      drawQr(qrHost, qrcode);
    } else if (loadQrLibrary && qrHost.dataset.library) {
      Promise.resolve(loadQrLibrary(qrHost.dataset.library)).then(
        (library) => drawQr(qrHost, library),
        () => {},
      );
    }
  }

  function init(root, { matchesDesktop, qrcode, loadQrLibrary, userAgent }) {
    if (matchesDesktop()) showQr(root, { qrcode, loadQrLibrary });
    // The theme editor can run this script again for a section it already set up.
    if (root.dataset.linksCardReady) return;
    root.dataset.linksCardReady = 'true';
    root.querySelectorAll('[data-links-card-save]').forEach((button) => {
      button.addEventListener('click', () => {
        if (isInAppBrowser(userAgent)) showInAppNote(root);
        else downloadVCard(contactFrom(root));
      });
    });
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { buildVCard, escapeVCardValue, qrSvg, init, isInAppBrowser, downloadVCard };
    return;
  }

  // Register document-level listeners once, even if the editor re-runs this file.
  if (window.linksCardLoaded) return;
  window.linksCardLoaded = true;

  let qrLibrary;
  function loadQrLibrary(src) {
    qrLibrary ||= new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve(window.qrcode);
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return qrLibrary;
  }

  const desktop = window.matchMedia(DESKTOP_QUERY);
  const options = () => ({ matchesDesktop: () => desktop.matches, qrcode: window.qrcode, loadQrLibrary, userAgent: navigator.userAgent });
  const initAll = () => document.querySelectorAll('.links-card').forEach((root) => init(root, options()));

  initAll();
  // Draw the QR if the window grows past the breakpoint after load.
  desktop.addEventListener('change', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
